import * as React from 'react';
import { fetchAdminGeneralInfo } from '../dashboardApi';
import { AdminGeneralInfoResult } from '../../../models/adminGeneral';
import { NotificationService } from '../../../common/notification';

export type UseDashboardDataArgs = {
    fromIso: string;
    toIso: string;
};

export function useDashboardData(args: UseDashboardDataArgs) {
    const { fromIso, toIso } = args;
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<AdminGeneralInfoResult | null>(null);

    const isValid = (v: AdminGeneralInfoResult): boolean => {
        return v != null && typeof v.online === 'number' && typeof v.totalUsers === 'number';
    };

    const load = React.useCallback(async () => {
        try {
            setLoading(true);
            const res = await fetchAdminGeneralInfo({ from: fromIso, to: toIso });
            if (res.result && res.value && isValid(res.value)) {
                setData(res.value);
            } else {
                setData(null);
                NotificationService.alertError('Не удалось загрузить общую статистику');
            }
        } catch (e) {
            setData(null);
            NotificationService.alertError('Ошибка загрузки общей статистики');
        } finally {
            setLoading(false);
        }
    }, [fromIso, toIso]);

    React.useEffect(() => {
        load();
    }, [load]);

    return { loading, data, reload: load } as const;
}


